
import { toggleBooleanAttribute } from "PARENT/utilities/attributes.js";
import { getById } from "PARENT/utilities/querySelector.js";
import { toggleScroll } from "PARENT/utilities/toggleScroll.js";


const header = document.getElementById( 'site-header' );

const primaryMenuToggle = document.getElementById( 'primary-menu-toggle' );
const primaryMenu = document.getElementById( 'primary-menu' );

const sideMenu = document.getElementById( 'side-menu' );
const sideMenuOpen = document.getElementById( 'side-menu-open' );
const sideMenuClose = document.getElementById( 'side-menu-close' );


const headerSearchToggle = /** @type {HTMLButtonElement} */ ( getById( 'site-header-search-toggle' ) );
const headerSearch = /** @type {HTMLElement} */ ( getById( 'site-header-search' ) );


primaryMenuToggle?.addEventListener( 'click', () => {
    toggleMenu( 'primary' );
} );

primaryMenu?.querySelectorAll( 'a' ).forEach( link => {
    link.addEventListener( 'click', () => {
        closeMenus();
    } );
} );

sideMenuOpen?.addEventListener( 'click', () => {
    openMenu( 'side' );
} );

sideMenuClose?.addEventListener( 'click', () => {
    closeMenus();
} );

sideMenu?.addEventListener( 'click', ( /** @type {Event} */ e ) => {
    if ( e?.target?.tagName !== 'A' ) return;
    closeMenus();
} );

headerSearchToggle?.addEventListener( 'click', toggleSearch );


/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu ) {
    header?.setAttribute( 'data-menu-active', menu );
    toggleScroll( false );
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

function toggleSearch() {
    headerSearch?.classList.toggle( 'show-search' );
    toggleBooleanAttribute( 'aria-expanded', headerSearchToggle );
}

function closeSearch() {
    headerSearch?.classList.remove( 'show-search' );
    headerSearchToggle?.setAttribute( 'aria-expanded', 'false' );
}

function openSearch() {
    if ( window.innerWidth < 1024 ) return;
    headerSearch?.classList.add( 'show-search' );
    headerSearchToggle?.setAttribute( 'aria-expanded', 'true' );
}


/**
 * Handles the visibility of the header search bar based on
 * whether an existing search bar on the page is in view or not
 */
const searchWatcher = new IntersectionObserver( handleSearchVisibility );
const searchElements = document.querySelectorAll( ':not(.site-header) .tour-search' );
searchElements.forEach( element => {
    searchWatcher.observe( element );
} );

function handleSearchVisibility( entries ) {
    let intersecting = false;
    entries.forEach( entry => {
        if ( !entry.isIntersecting ) return;
        intersecting = true;
    } );
    intersecting ? closeSearch() : openSearch();
}
